import { render, staticRenderFns } from "./WorkerSafetyAccidentInvestigationReport.vue?vue&type=template&id=45efeba0&scoped=true"
import script from "./WorkerSafetyAccidentInvestigationReport.vue?vue&type=script&lang=js"
export * from "./WorkerSafetyAccidentInvestigationReport.vue?vue&type=script&lang=js"
import style0 from "./WorkerSafetyAccidentInvestigationReport.vue?vue&type=style&index=0&id=45efeba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45efeba0",
  null
  
)

export default component.exports